import { AxiosService } from './axiosService';

export class CustomerService extends AxiosService {
    async getCustomers(pageSize, pageIndex, sortField, sortDirection) {
        try {
            const { data } = await this.axios.get('/customers', {
                params: {
                    pageSize: pageSize,
                    pageIndex: pageIndex,
                    sortBy: sortField,
                    orderBy: sortDirection
                },
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getAllCustomers(sortField, sortDirection) {
        try {
            const { data } = await this.axios.get('/customers', {
                params: {
                    sortBy: sortField,
                    orderBy: sortDirection
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getUtilityAccounts(groupIds) {
        try {
            const { data } = await this.axios.get('/utility', {
                params:{groupIds: groupIds}
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getCustomerById(customerId) {
        try {
            const { data } = await this.axios.get(`/customers/${customerId}`);
            return data.data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postCustomer(companyName, firstName, lastName, email, phone, addressOne, addressTwo, state, city, zip, distributorId) {
        try {
            const { data } = await this.axios.post('/customers', {
                companyName,
                firstName,
                lastName,
                email,
                phone,
                address_One: addressOne,
                address_Two: addressTwo,
                state,
                city,
                zip,
                distributorId
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async editCustomer(id, companyName, firstName, lastName, email, phone, addressOne, addressTwo, state, city, zip, distributorId, groupId) {
        try {
            const { data } = await this.axios.put('/customers', {
                id,
                companyName,
                firstName,
                lastName,
                email,
                phone,
                address_One: addressOne,
                address_Two: addressTwo,
                state,
                city,
                zip,
                distributorId, groupId
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteCustomer(id) {
        try {
            const { data } = await this.axios.delete('/customers', {
                data: {
                    id
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async createApiKey(customerId) {
        try {
            const { data } = await this.axios.post('/customer/apikey', {
                customerId
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async toggleApiSubscription(customerId, subscriptionState) {
        try {
            const { data } = await this.axios.post('/customer/toggleApiSubscription', {
                customerId,
                subscriptionState
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getDistinctPoints(customerId, equipmentIds, allPoints = true) {
        try {
            const { data } = await this.axios.get('/customer/points', {
                params: {
                    customerId,
                    equipmentIds,
                    allPoints
                },
                paramsSerializer: {
                    indexes: null
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getDistinctFunctions(customerId, equipmentIds, allFunctions = true) {
        try {
            const { data } = await this.axios.get('/customer/functions', {
                params: {
                    customerId,
                    equipmentIds,
                    allFunctions
                },
                paramsSerializer: {
                    indexes: null
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if (e?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const customerService = new CustomerService();
